import React, { useContext } from "react";
import { MeetingFormContext } from "../../../MeetingFormContext";
import Form from "antd/lib/form/Form";
import { Input } from "antd";

export const ObjectiveInput = (props: any) => {
  const meetingFormContext = useContext(MeetingFormContext);
  const { form, worktableMeeting, onInputChange } = meetingFormContext;
  const { getFieldDecorator } = form;

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onInputChange({
      key: event.target.name,
      value: event.target.value
    });
  };

  return (
    <Form.Item
      label="Objetivo de la reunión">
      {getFieldDecorator("objective", {
        rules: [
          {
            required: true,
            message: "Por favor, ingresa el objetivo de la reunión."
          }
        ],
        initialValue: worktableMeeting?.objective
      })(
        <Input
          id="objective"
          name="objective"
          type="text"
          onChange={onChange} />
      )}
    </Form.Item>
  );
};
